import { c as a } from "./index-BblTVfVY.mjs";
import { S as $ } from "./index-BblTVfVY.mjs";
import { setupWebVitalsReporting as c } from "./metrics.mjs";
import { setupTracing as g } from "./tracing.mjs";
import { l as y, t as S } from "./callback-DI3dXP55.mjs";
import { m as W } from "./metrics-api-Cn5wfR4o.mjs";
function f({
  collectorBaseUrl: t,
  batchLogs: s,
  exportIntervalsMillis: o,
  ...r
}) {
  const i = `${t}/logs`, m = `${t}/traces`, p = `${t}/metrics`;
  return {
    logging: {
      setup: a({ url: i, batchLogs: s, ...r })
    },
    tracing: {
      setup: (e = {}) => g({ url: m, ...r, ...e })
    },
    metrics: {
      setupWebVitals: (e = {}) => c({
        url: p,
        exportIntervalsMillis: o,
        ...r,
        ...e
      })
    }
  };
}
export {
  $ as SeverityText,
  f as createTelemetry,
  y as logs,
  W as metrics,
  S as trace
};
